module.exports = __webpack_public_path__ + "img/bmcl_gallery12.b81a6a72.jpg";